export default {
  PAGE: {
    LOGIN: '/login'
  }
} 